import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';

function ConfirmEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('Verifying your email...');
  const navigate = useNavigate();

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        // Get the token_hash and type from URL parameters
        const token_hash = searchParams.get('token_hash');
        const type = searchParams.get('type');

        if (!token_hash || type !== 'email') {
          setStatus('error');
          setMessage('Invalid confirmation link. Please check your email and try again.');
          return;
        }

        // Verify the email using Supabase
        const { error } = await supabase.auth.verifyOtp({
          token_hash,
          type: 'email',
        });

        if (error) {
          console.error('Email confirmation error:', error);
          setStatus('error');
          setMessage(
            error.message || 'Failed to confirm email. The link may have expired or is invalid.'
          );
        } else {
          setStatus('success');
          setMessage('Email confirmed successfully! You can now use your account.');
        }
      } catch (err) {
        console.error('Unexpected error during email confirmation:', err);
        setStatus('error');
        setMessage('An unexpected error occurred. Please try again.');
      }
    };

    confirmEmail();
  }, [searchParams]);

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="page-container">
      <div className="page-content" style={{ textAlign: 'center', paddingTop: '60px' }}>
        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
          {status === 'verifying' && (
            <>
              <h1>Verifying Email</h1>
              <p>{message}</p>
              <div style={{ margin: '20px 0' }}>
                <div className="loading-spinner"></div>
              </div>
            </>
          )}

          {status === 'success' && (
            <>
              <div style={{ fontSize: '64px', marginBottom: '20px' }}>✓</div>
              <h1 style={{ color: '#4B9CD3' }}>Email Confirmed!</h1>
              <p>{message}</p>
              <p style={{ marginTop: '20px' }}>
                You can now return to the Puck Stats app and sign in with your account.
              </p>
              <button
                onClick={handleGoHome}
                style={{
                  marginTop: '30px',
                  padding: '12px 24px',
                  fontSize: '16px',
                  backgroundColor: '#4B9CD3',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
              >
                Go to Home
              </button>
            </>
          )}

          {status === 'error' && (
            <>
              <div style={{ fontSize: '64px', marginBottom: '20px' }}>✗</div>
              <h1 style={{ color: '#d32f2f' }}>Confirmation Failed</h1>
              <p>{message}</p>
              <p style={{ marginTop: '20px' }}>
                Please try signing up again in the Puck Stats app, or contact support if the
                problem persists.
              </p>
              <button
                onClick={handleGoHome}
                style={{
                  marginTop: '30px',
                  padding: '12px 24px',
                  fontSize: '16px',
                  backgroundColor: '#4B9CD3',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
              >
                Go to Home
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ConfirmEmail;
